export default __webpack_public_path__ + "static/media/about.908157e0.png";